"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";

const About = () => {
  return (
    <section
      id="about"
      className="min-h-screen bg-primaryColor-darker/45 px-6 py-10 sm:py-30"
    >
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12">
        {/* Image container */}
        <motion.div
          className="w-full lg:w-1/2 flex justify-center"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.3,delay: 0.1, ease: "easeInOut" }}
        >
          <motion.div>
  <Image
    src="/about.webp"
    alt="About Design Nook"
    priority={true}        // Use priority boolean, not fetchPriority
    width={480}            // Provide actual width (max width you want)
    height={320}           // Provide actual height matching aspect ratio
    className="rounded-lg shadow-xl w-[260px] sm:w-[360px] md:w-[400px] lg:w-[480px] object-cover"
  />
</motion.div>
        </motion.div>

        {/* Text container */}
        <motion.div
          className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left gap-6 text-[#3E2F2F]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.3, delay: 0.1, ease: "easeInOut" }}
        >
          <h2 className="font-serif text-4xl font-semibold sm:text-5xl lg:text-6xl leading-tight text-[#A65D5D]">
            Timeless Design. Thoughtfully Curated.
          </h2>

          <p className="text-lg md:text-xl leading-relaxed max-w-xl font-normal font-sans text-[#6B4F4F]">
           <span className="text-[#B25B5B] font-semibold font-serif">Design Nook</span>, we craft interiors that blend elegance, comfort, and style . Whether transforming a single room or designing an entire property, we create bespoke spaces tailored to your unique taste. Every detail, from textures to layouts, is thoughtfully curated to elevate your environment into a luxurious and harmonious experience.
          </p>

          <p className="text-md md:text-lg font-semibold font-sans max-w-xl text-[#6B4F4F]">
            Curious about our journey and design philosophy?
          </p>

          <Link
            href="/brand"
            className="mt-4 inline-block font-manrope font-semibold text-lg px-6 py-3 rounded-lg transition duration-300 bg-[#A65D5D] hover:bg-[#8C4A4A] text-white"
          >
            Discover the story behind Design Nook
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
